import type { Exercise, ExerciseFormData } from "api/services/content/schemas/exercises";
import type { Locale } from "api/services/content/schemas/shared";
import type { ValidLocale } from "types/validLocale";

export const LOCALES: Locale[] = ["en-gb", "en-us", "sv-se"];

interface GetDefaultValuesArgs {
  exercise?: Exercise;
  locale?: ValidLocale;
}

export function getDefaultValues({ exercise, locale }: GetDefaultValuesArgs): ExerciseFormData {
  const lowerCasedLocale = (locale || process.env.REACT_APP_LOCALE || "en-gb").toLowerCase() as Locale;

  const defaultValues: ExerciseFormData = {
    primary_function: exercise?.primary_function || "strength",
    target_joints: exercise?.target_joints || [],
    levels: [
      {
        duration_unit: exercise?.levels[0]?.duration_unit || "repetitions",
        equipment: exercise?.levels[0]?.equipment || [],
        image_url: exercise?.levels[0]?.image_url || "",
        movement: exercise?.levels[0]?.movement || "",
        position: exercise?.levels[0]?.position || "",
        reps: exercise?.levels[0]?.reps || "",
        sets: exercise?.levels[0]?.sets || 0,
        translations: [
          {
            about: exercise?.levels?.[0]?.about || "",
            caption_file_url: exercise?.levels?.[0]?.caption_file_url || "",
            locale: lowerCasedLocale,
            tip_description: exercise?.levels?.[0]?.tip_description || "",
            tip_title: exercise?.levels?.[0]?.tip_title || "",
            title: exercise?.levels?.[0]?.title || "",
          },
        ],
        video: {
          video_file_url: exercise?.levels?.[0]?.video_file_url || "",
          video_thumbnail_file_url: exercise?.levels?.[0]?.video_thumbnail_file_url || "",
        },
      },
    ],
  };

  return defaultValues;
}
